@if (userService.ACTIONS_MAPPED) {
  <div class="d-flex">
    <!-- left sidebar -->
    <app-left-sidebar navClasses="left-side-menu-detached"></app-left-sidebar>
    <div class="main-layout-container">
      <div class="layout-sticky-header" appSticky [stickyClass]="'fixed-topbar'">
        @if (showTrialBanner) {
          <div class="trial-banner-wrapper">
            <app-banner
              [bannerInfo]="bannerInfo$ | async"
              (bannerCTAClick)="onBannerCTAClick($event)">
            </app-banner>
          </div>
        }
        <div class="container d-flex">
          <div class="topbar-wrapper">
            <app-detached-topbar class="detached-topbar"></app-detached-topbar>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="wrapper">
          <div class="content-page">
            <div class="content">
              <!-- content-->
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<app-ui-confirmation-modal (action)="handleTrialConfirmation($event)" #confirmationModalRef></app-ui-confirmation-modal>
